import { Button, ButtonContainer } from '@vwfs-bronson/bronson-react';

export interface FromNavigationButtonsProps {
  canGoForward: boolean;
  disableForward?: boolean;
  disabledBackButton?: boolean;
  canGoBack?: boolean;
  backName?: string;
  forwardName: string;
  goBackHandler?: () => void;
  goForwardHandler?: () => void;
}

export const FormNavigationButtons = ({
  canGoForward,
  disableForward = false,
  disabledBackButton = false,
  canGoBack = false,
  backName,
  forwardName,
  goBackHandler,
  goForwardHandler,
}: FromNavigationButtonsProps) => {
  return (
    <ButtonContainer center>
      {canGoBack && (
        <Button type="button" secondary disabled={disabledBackButton} full onClick={goBackHandler}>
          {backName}
        </Button>
      )}

      {canGoForward && (
        <Button full type="button" disabled={disableForward} onClick={goForwardHandler}>
          {forwardName}
        </Button>
      )}
    </ButtonContainer>
  );
};
